var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo, useEffect, useState } from 'react';
import { MessageResource } from '@medable/i18n-core';
import { Locale } from 'libs.i18n-core';
import { detectUserLanguage } from 'libs.react';
// translations imported here should match available locales based on https://gitlab.medable.com/l10n/continuous-localization/-/blob/main/config.json?ref_type=heads#L128
const translationsMap = {
    'en-US': () => import('@medable/localization-product-web-monorepo-bundled/en-US.json'),
    'es-US': () => import('@medable/localization-product-web-monorepo-bundled/es-US.json'),
    'fr-FR': () => import('@medable/localization-product-web-monorepo-bundled/fr-FR.json'),
    'ja-JP': () => import('@medable/localization-product-web-monorepo-bundled/ja-JP.json'),
    'ko-KR': () => import('@medable/localization-product-web-monorepo-bundled/ko-KR.json'),
    'zh-Hans-CN': () => import('@medable/localization-product-web-monorepo-bundled/zh-Hans-CN.json'),
    'zh-Hant-TW': () => import('@medable/localization-product-web-monorepo-bundled/zh-Hant-TW.json'),
};
export const useMessageProviderForDetectedLocale = () => {
    const [translations, setTranslations] = useState({});
    const detectedLocale = useMemo(() => detectUserLanguage({
        supportedLocales: Object.keys(translationsMap),
        fallbackLocale: Locale.en_US,
    }), []);
    useEffect(() => {
        const loadTranslations = () => __awaiter(void 0, void 0, void 0, function* () {
            const module = yield translationsMap[detectedLocale]();
            setTranslations(module.default || {});
        });
        loadTranslations();
    }, [detectedLocale]);
    // this can be updated in the future to include translations from firebase and other sources
    const messageProvider = (locale) => {
        return new MessageResource(locale, translations);
    };
    return {
        detectedLocale,
        messageProvider,
    };
};
